<template>
  <div class="articles__list">
    <div class="articles__list-item active">
      <div class="articles-items">
        <slot name="articles"></slot>
        <a v-for="(item, key) in items" :id="item.editAreaId" :key="key" class="article-item" :class="{'article-item--big' : item.IS_BIG}" :href="item.DETAIL_PAGE_URL">
          <div class="article-item__img">
            <picture>
              <source media="(min-width: 768px)" :srcset="item.PICTURE ? item.PICTURE.src : ''">
              <source media="(max-width: 767px)" :srcset="item.PICTURE_MOBILE ? item.PICTURE_MOBILE.src : ''">
              <img :alt="item.IMG_DESCR ? item.IMG_DESCR : 'Изображение'" loading="lazy">
            </picture>
          </div>
          <div class="article-item__title">{{ item.NAME }}</div>
          <div class="article-item__bottom">
            <div v-for="(tag, key) in item.TAGS" :key="'t' + key" class="article-item__bottom-section">
              {{ tag }}
            </div>
            <div class="article-item__bottom-date">{{ item.ACTIVE_FROM }}</div>
          </div>
        </a>
      </div>
      <slot v-if="!all" name="pagination" :getMore="getMore"></slot>
      <!--      <div v-if="!all" @click="debounce(loadMore)" class="articles-btn btn">Загрузить еще</div>-->
    </div>
  </div>

</template>

<script>
import tools from "@/components/mixins/tools";

export default {
  name   : "ArticlesList",
  props  : {
    pages      : Number,
    nav_num    : Number,
    items_prop : Array,
    tag        : String
  },
  mixins : [tools],
  data()
  {
    return {
      page  : 2,
      items : [],
      all   : false
    };
  },
  methods : {
    loadMore()
    {
      if(this.all)
        return;
      let query = (document.location.search === "" ? "?" : "&") + "pagination=Y&PAGEN_" + this.nav_num + "=" + this.page;
      fetch(document.location.href + query, {
        method : "GET"
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.data.length > 0)
        {
          for(let item in result.data)
            this.items.push(result.data[item]);
        }
        this.page++;
        if(this.pages < this.page)
        {
          this.all = true;
        }
      });
    },
    getMore()
    {
      this.debounce(this.loadMore, false);
    }
  },
  created()
  {
    this.all = this.pages < this.page;
  }
};
</script>

<style scoped>

</style>